import { useForm } from '@inertiajs/react'
import { FormEvent } from 'react'

interface Props {
  errors?: Record<string, string[]>
}

export default function ForgotPassword({ errors }: Props) {
  const { data, setData, post, processing } = useForm({
    user: {
      email: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/users/password')
  }

  const emailError = errors?.email?.join(', ')

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">LendSolo</h1>
          <p className="text-gray-500 mt-1">Reset your password</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 space-y-5">
          <p className="text-sm text-gray-600">
            Enter the email address for your account and we&apos;ll send you a link to choose a new password.
          </p>

          {emailError && (
            <div className="bg-red-50 text-red-700 text-sm px-4 py-3 rounded-lg">
              Email {emailError}
            </div>
          )}

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              autoFocus
              required
              value={data.user.email}
              onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            />
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-full py-2.5 px-4 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:opacity-50 transition-colors"
          >
            {processing ? 'Sending...' : 'Send reset link'}
          </button>

          <p className="text-center text-sm text-gray-600">
            Remembered it?{' '}
            <a href="/users/sign_in" className="text-emerald-600 hover:text-emerald-700 font-medium">
              Back to sign in
            </a>
          </p>
        </form>
      </div>
    </div>
  )
}
